jQuery(document).ready(function ($) {
	/**/

	if ($(window).width() > 1008) {
		if ($('.j-scroll').length > 0) {
			$('.j-scroll').on('click', function (e) {
				e.preventDefault();
				var offset = 110;
				var target = this.hash;
				if ($(this).data('offset') != undefined)
					offset = $(this).data('offset');
				$('html, body')
					.stop()
					.animate(
						{
							scrollTop: $(target).offset().top - offset,
						},
						500,
						'swing',
						function () {
							// window.location.hash = target;
						}
					);
			});
		}
	} else {
	}
});
